/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {refundTransaction} from '../api'

export const useMutationRefundTransaction = createReactQueryMutationHook('refundTransaction', refundTransaction)
